import { Link } from "react-router-dom";

export function HomePage() {
  return (
    <div className="page center-page">
      <div className="card hero-card">
        <img className="brand-logo hero" src="/dronevision-logo.png" alt="DroneVision" />
        <h1>3D Viewer</h1>
        <p className="muted">
          Share georeferenced photogrammetry models with your customers. Open a link you received,
          or sign in to manage projects.
        </p>
        <div className="row gap">
          <Link className="btn primary" to="/admin">
            Admin
          </Link>
        </div>
      </div>
    </div>
  );
}
